// @ts-nocheck
import { type TrackingLabData } from './HandTrackerAR';

export interface GestureActions {
    onSwipeLeft: () => void;
    onSwipeRight: () => void;
    onZoom: (delta: number) => void;       // +ve = zoom in
    onPan: (dx: number) => void;           // normalised delta
    onFaceYaw: (yaw: number) => void;      // continuous
    onFacePitch: (pitch: number) => void;    // continuous
    onSwipeUp: () => void;                 // add 1.0 mL
    onSwipeDown: () => void;               // add 0.1 mL
}

class SwipeBuffer {
    history: { x: number; y: number; time: number }[] = [];

    addPoint(x: number, y: number) {
        const now = Date.now();
        this.history.push({ x, y, time: now });
        // Keep only last 400ms
        this.history = this.history.filter(p => now - p.time < 400);
    }

    detectSwipe(): 'left' | 'right' | 'up' | 'down' | null {
        if (this.history.length < 5) return null;

        const first = this.history[0];
        const last = this.history[this.history.length - 1];

        const dx = last.x - first.x;
        const dy = last.y - first.y;

        // Threshold for a fast swipe
        if (Math.abs(dx) > 0.15 && Math.abs(dx) > Math.abs(dy)) {
            this.history = []; // reset after detection
            return dx > 0 ? 'right' : 'left';
        }

        if (Math.abs(dy) > 0.15 && Math.abs(dy) > Math.abs(dx)) {
            this.history = []; // reset
            return dy > 0 ? 'down' : 'up';
        }

        return null;
    }

    clear() {
        this.history = [];
    }
}

export class GestureProcessor {
    private leftBuffer = new SwipeBuffer();
    private rightBuffer = new SwipeBuffer();
    private lastZoomY = 0;
    private lastPanX = 0;

    // Cooldown to prevent double-firing discrete gestures
    private lastSwipeTime = 0;

    processFrame(data: TrackingLabData, actions: GestureActions) {
        const now = Date.now();

        // 1. Face Yaw & Pitch (Continuous)
        if (Math.abs(data.faceYaw) > 0.02) {
            actions.onFaceYaw(data.faceYaw);
        }
        if (Math.abs(data.facePitch) > 0.02) {
            actions.onFacePitch(data.facePitch);
        }

        const isLeft = data.left.isPresent;
        const isRight = data.right.isPresent;

        // 2. Joystick Zoom (Fist Up/Down) — LEFT HAND ONLY
        const activeHand = isLeft ? data.left : null;
        if (activeHand && activeHand.isFist) {
            const currentY = activeHand.wrist.y;
            if (this.lastZoomY !== 0) {
                const dy = currentY - this.lastZoomY;
                // Deadzone
                if (Math.abs(dy) > 0.005) {
                    // Moving hand UP (negative dy) = zooming IN (push scrollwheel up)
                    // Moving hand DOWN (positive dy) = zooming OUT
                    actions.onZoom(-dy * 12.0);
                }
            }
            this.lastZoomY = currentY;
        } else {
            this.lastZoomY = 0;
        }

        // 3. Both Hands Pan
        // [DISABLED FOR NOW]
        /*
        if (isLeft && isRight) {
            const panX = (data.left.indexTip.x + data.right.indexTip.x) / 2;
            if (this.lastPanX !== 0) {
                const panDelta = panX - this.lastPanX;
                if (Math.abs(panDelta) > 0.002) {
                    actions.onPan(panDelta);
                }
            }
            this.lastPanX = panX;

            this.leftBuffer.clear();
            this.rightBuffer.clear();
            return;
        } else {
            this.lastPanX = 0;
        }
        */

        // 4. One Hand Swipes
        // [DISABLED FOR NOW]
        /*
        const checkSwipe = (buffer: SwipeBuffer) => {
            if (now - this.lastSwipeTime < 800) return;

            const swipe = buffer.detectSwipe();
            if (swipe) {
                this.lastSwipeTime = now;
                if (swipe === 'left') actions.onSwipeLeft();
                if (swipe === 'right') actions.onSwipeRight();
                if (swipe === 'up') actions.onSwipeUp();
                if (swipe === 'down') actions.onSwipeDown();
            }
        };

        if (isLeft) {
            this.leftBuffer.addPoint(data.left.wrist.x, data.left.wrist.y);
            checkSwipe(this.leftBuffer);
        } else {
            this.leftBuffer.clear();
        }

        if (isRight) {
            this.rightBuffer.addPoint(data.right.wrist.x, data.right.wrist.y);
            checkSwipe(this.rightBuffer);
        } else {
            this.rightBuffer.clear();
        }
        */
    }
}
